import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "success-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = {
  key: 1,
  class: "success-container"
}
const _hoisted_4 = { class: "status-icon" }
const _hoisted_5 = { class: "status-title" }
const _hoisted_6 = { class: "status-message" }
const _hoisted_7 = {
  key: 0,
  class: "subscription-details"
}
const _hoisted_8 = { class: "detail-row" }
const _hoisted_9 = { class: "detail-label" }
const _hoisted_10 = { class: "detail-value" }
const _hoisted_11 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_12 = { class: "detail-label" }
const _hoisted_13 = { class: "detail-value" }
const _hoisted_14 = { class: "detail-row" }
const _hoisted_15 = { class: "detail-label" }
const _hoisted_16 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_17 = { class: "detail-label" }
const _hoisted_18 = { class: "detail-value" }
const _hoisted_19 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_20 = { class: "detail-label" }
const _hoisted_21 = { class: "detail-value" }
const _hoisted_22 = { class: "action-buttons" }
const _hoisted_23 = { class: "back-link" }
const _hoisted_24 = {
  key: 0,
  class: "next-steps"
}
const _hoisted_25 = { class: "steps-list" }
const _hoisted_26 = { class: "step-item" }
const _hoisted_27 = { class: "step-content" }
const _hoisted_28 = { class: "step-item" }
const _hoisted_29 = { class: "step-content" }
const _hoisted_30 = { class: "step-item" }
const _hoisted_31 = { class: "step-content" }

import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { toast } from "@/common/utils/toast";
// import { subscriptionShow } from "@/common/api/rest/";
// import { invoiceShow } from "@/common/api/rest/payment/invoice";

import { DefaultTheme } from "@/common/themes";
// import type { SubscriptionType } from "@/common/types/subscription/subscription";


export default /*@__PURE__*/_defineComponent({
  __name: 'success',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();

const isLoading = ref(true);
const subscription = ref<any | null>(null);
const invoice = ref<any>(null);

const paymentStatus = computed(() => {
  if (!subscription.value) return "processing";

  switch (subscription.value.status) {
    case "PAID":
      return "success";
    case "PENDING":
      return "pending";
    case "CANCELED":
      return "canceled";
    case "REFUNDED":
      return "refunded";
    default:
      return "processing";
  }
});

const statusIcon = computed(() => {
  switch (paymentStatus.value) {
    case "success":
      return "✅";
    case "pending":
      return "⏳";
    case "canceled":
      return "❌";
    case "refunded":
      return "↩️";
    default:
      return "🔄";
  }
});

const statusTitle = computed(() => {
  switch (paymentStatus.value) {
    case "success":
      return t("checkout.success.title");
    case "pending":
      return t("checkout.success.pending_title");
    case "canceled":
      return t("checkout.success.canceled_title");
    case "refunded":
      return t("checkout.success.refunded_title");
    default:
      return t("checkout.success.processing_title");
  }
});

const statusMessage = computed(() => {
  switch (paymentStatus.value) {
    case "success":
      return t("checkout.success.message");
    case "pending":
      return t("checkout.success.pending_message");
    case "canceled":
      return t("checkout.success.canceled_message");
    case "refunded":
      return t("checkout.success.refunded_message");
    default:
      return t("checkout.success.processing_message");
  }
});

async function fetchSubscriptionData() {
  //   try {
  //     // Buscar subscription_id da URL ou do store
  //     const subscriptionId = route.query.subscription_id as string;
  //     if (!subscriptionId) {
  //       // Se não tem subscription_id, tentar buscar do store
  //       const userSubscription = store.getters.user?.subscription_id;
  //       if (!userSubscription) {
  //         // Redirecionar para planos se não encontrar
  //         router.push("/plans");
  //         return;
  //       }
  //     }
  //     // Buscar dados da subscription
  //     if (subscriptionId) {
  //       const response = await subscriptionShow(subscriptionId);
  //       if (response.success) {
  //         subscription.value = response.data;
  //         // Se a subscription tem invoice_id, buscar invoice
  //         if (response.data.metadata) {
  //           try {
  //             const metadata = JSON.parse(response.data.metadata);
  //             if (metadata.invoice_id) {
  //               const invoiceResponse = await invoiceShow(metadata.invoice_id);
  //               if (invoiceResponse.success) {
  //                 invoice.value = invoiceResponse.data;
  //               }
  //             }
  //           } catch (error) {
  //             console.error("Error parsing metadata:", error);
  //           }
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching subscription:", error);
  //     toast({
  //       message: t("error.default"),
  //       type: "error",
  //     });
  //   } finally {
      isLoading.value = false;
  //   }
}

function goToDashboard() {
  router.push("/dashboard");
}

function goToPlans() {
  router.push("/plans");
}

function goToSupport() {
  router.push("/support");
}

onMounted(() => {
  fetchSubscriptionData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DefaultTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spinner" }, null, -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(t)("common.loading")), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["status-card", paymentStatus.value])
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(statusIcon.value), 1),
                _createElementVNode("h1", _hoisted_5, _toDisplayString(statusTitle.value), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(statusMessage.value), 1),
                (subscription.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("checkout.success.subscription_id")), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(subscription.value.subscription_id), 1)
                      ]),
                      (subscription.value.stripe_subscription_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)("checkout.success.stripe_id")), 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(subscription.value.stripe_subscription_id), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("checkout.success.status")), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["detail-value status-badge", paymentStatus.value])
                        }, _toDisplayString(_unref(t)(`checkout.success.status_${paymentStatus.value}`)), 3)
                      ]),
                      (invoice.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (invoice.value.amount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("checkout.success.amount")), 1),
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: invoice.value.currency || "BRL",
                    }).format(invoice.value.amount / 100)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (invoice.value.paid_at)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)("checkout.success.paid_at")), 1),
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(new Date(invoice.value.paid_at).toLocaleDateString("pt-BR")), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  (paymentStatus.value === 'success')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary",
                        onClick: goToDashboard
                      }, _toDisplayString(_unref(t)("checkout.success.go_to_dashboard")), 1))
                    : _createCommentVNode("", true),
                  (
                paymentStatus.value === 'canceled' || paymentStatus.value === 'refunded'
              )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-primary",
                        onClick: goToPlans
                      }, _toDisplayString(_unref(t)("checkout.success.go_to_plans")), 1))
                    : _createCommentVNode("", true),
                  (paymentStatus.value === 'pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-secondary",
                        onClick: goToSupport
                      }, _toDisplayString(_unref(t)("checkout.success.contact_support")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(goToPlans, ["prevent"]),
                    class: "link"
                  }, _toDisplayString(_unref(t)("checkout.success.back_to_plans")), 1)
                ])
              ], 2),
              (paymentStatus.value === 'success')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("h2", null, _toDisplayString(_unref(t)("checkout.success.next_steps_title")), 1),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "step-number" }, "1", -1)),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("h3", null, _toDisplayString(_unref(t)("checkout.success.step1_title")), 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(t)("checkout.success.step1_description")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "step-number" }, "2", -1)),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("h3", null, _toDisplayString(_unref(t)("checkout.success.step2_title")), 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(t)("checkout.success.step2_description")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "step-number" }, "3", -1)),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("h3", null, _toDisplayString(_unref(t)("checkout.success.step3_title")), 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(t)("checkout.success.step3_description")), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})